import { BiometricIdentityVerificationRequest } from "@wingspanhq/wingspan-api-sdk";

import {
  ContextItem,
  RequirementContextType,
  RequirementStatusViewProps,
  RequirementTableItemData
} from "../../../../types";

import { getIdentityVerificationRequirementStatus } from "./getIdentityVerificationRequirementStatus";

export const getIdentityVerificationPayerRequirementStatus = (
  requirement: RequirementTableItemData,
  contextItem: ContextItem,
  identityVerification: BiometricIdentityVerificationRequest | undefined
): RequirementStatusViewProps => {
  return getIdentityVerificationRequirementStatus(
    requirement,
    contextItem,
    identityVerification,
    RequirementContextType.Payee
  );
};
